import React from 'react';
import type { DepartmentValue } from '../types/product';

interface DepartmentBadgeProps {
  department: DepartmentValue;
}

const DEPARTMENT_STYLES: Record<DepartmentValue, React.CSSProperties> = {
  'מוסדי': { backgroundColor: '#f3e5f5', color: '#6a1b9a' },
  'קמעונאי': { backgroundColor: '#e8f5e9', color: '#1b5e20' },
};

const badgeBaseStyle: React.CSSProperties = {
  display: 'inline-block',
  padding: '2px 8px',
  borderRadius: '12px',
  fontSize: '0.75rem',
  fontWeight: 600,
  whiteSpace: 'nowrap',
};

export function DepartmentBadge({ department }: DepartmentBadgeProps): JSX.Element {
  const colorStyle = DEPARTMENT_STYLES[department];
  return (
    <span style={{ ...badgeBaseStyle, ...colorStyle }}>
      {department}
    </span>
  );
}
